// React-Screen CPOSIDScreen ("POS-ID Eingabe") - Strangler Phase 5.
// Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle posidscreen.js (aus
// lib/scripts/pos/components/CMP_CPOSIDScreen.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CPOSIDScreen.html, gezogen aus
// tests/visual-baseline/29-kassen-id.html.
//
// ENTSCHALT am 23.8.2026 - und damit der Nachweis, dass auch die
// EINGABE-Screens ohne Widget-Baum auskommen. Der Screen war die letzte
// Huelle, die noch behauptet hat, Fokus, NumPad und Scanner brauchten echte
// Legacy-Widgets. Brauchen sie nicht: React rendert das DOM
// (react/widgets.jsx), und die Handles tragen die Legacy-PROTOTYPEN, also
// laufen CInput.gotKey/gotOK/setFocus und CNumPad.clickWork/gotOK/gotCancel
// woertlich weiter. Was frueher der XML-Builder verdrahtet hat
// (posid.field.input, numPad.controlFields), stellt spec.mountLegacy nach
// dem Mount her - dort steht nur noch Verdrahtung, kein DOM-Bau.
//
// Alle Masse und Styles stammen aus der Baseline, nicht aus dem Gefuehl.
//
// Der Screen ist ausserdem der einzige, der KEIN Kind eines CMainPOS ist:
// die Kassa erzeugt ihn beim Start ohne Kassen-ID als Wurzel
// (new CPOSIDScreen("0")). Das funktioniert unveraendert, weil
// CComponentBuilder.doAddElement fuer eine Wurzel-ID den transmitDocument-
// Weg nimmt.
import { defineReactScreen } from '../bridge.js';
import { TextLabel, LabeledInputField, NumPad, Input, verdrahteLabeledInputField } from '../widgets.jsx';

function POSIDScreen({ bridge }) {
  return (
    <>
      {/* container (CFrame) */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', top: '17%', left: '21%', borderStyle: 'double',
                    borderWidth: '3px', height: '70%', width: '60vw' }}>
        <TextLabel bridge={bridge} pfad="0:0"
                   style={{ width: '100%', top: '0px', height: '10%' }}
                   text="POS-ID Eingabe"
                   textStyle={{ position: 'relative', bottom: '6px', marginTop: '10px',
                                fontWeight: 'bold', fontSize: '3vh' }} />
        <TextLabel bridge={bridge} pfad="0:1"
                   style={{ width: '100%', top: '15%' }}
                   text="Bitte POS-ID eingeben:"
                   textStyle={{ fontSize: '1.8vh', fontWeight: 'bold' }} />
        <LabeledInputField bridge={bridge} pfad="0:2"
                           style={{ width: '55vw', top: '28%', height: '5vh' }}
                           label="POS-ID:"
                           labelSpalteStyle={{ width: '22vw' }}
                           labelStyle={{ margin: '0px 0.1em 0px 0px', fontSize: '3.5vh',
                                         textAlign: 'right', width: '22vw' }}
                           feldSpalteStyle={{ width: '100%' }}
                           feldProps={{
                             style: { width: '100%' },
                             spaltenStyle: { width: '95%' },
                             inputStyle: { position: 'static', margin: 'auto', width: '95%' },
                             knopfStyle: { width: '2.5vw', height: '4vh', backgroundPosition: 'center center' },
                           }} />
        <NumPad bridge={bridge} pfad="0:3" typ="phone" ok cancel />
      </div>
      {/* hiddenInput: faengt den Fokus ab und gibt ihn ans Eingabefeld zurueck */}
      <Input bridge={bridge} pfad="1"
             style={{ width: '0px', position: 'absolute', bottom: '0px', right: '0px', border: '0px' }}
             attributes={{ onFocus_parameter_0: bridge.id }} />
    </>
  );
}

export const CPOSIDScreen = defineReactScreen({
  className: 'CPOSIDScreen',
  addclass: 'CPosIdScreen',
  htmlType: 'div',
  Screen: POSIDScreen,
  // Wurzel-Styles des Legacy-KONSTRUKTORS. Sie muessen hier stehen und nicht
  // in prepare(): CPOS.inputPOSID haengt zwischen Konstruktion und draw()
  // noch zIndex "1" an, und das steht im style-Attribut hinten.
  // (properties.defaultFocus aus dem Legacy-Konstruktor liest niemand.)
  rootStyles: {
    position: 'absolute',
    backgroundColor: '#DFDFDF',
    width: '100%',
    height: '100%',
    left: '0px',
    top: '0px',
  },
  prepare(bridge) {
    bridge.indexSessions = 0;
    bridge.POSSessions = Array();
  },
  // Nur noch VERDRAHTUNG - das DOM steht zu diesem Zeitpunkt schon (React).
  // Die Namen sind dieselben wie in LYT_posidScreen.xml, damit die Methoden
  // unten woertlich die alten bleiben koennen.
  mountLegacy(bridge) {
    bridge.nameComponent('0', 'container');
    bridge.nameComponent('0:2', 'posid');
    bridge.nameComponent('0:3', 'numPad');
    bridge.nameComponent('1', 'hiddenInput');

    const input = verdrahteLabeledInputField(bridge, '0:2');

    input.properties.OKcallback.cls = bridge;
    input.properties.OKcallback.fnc = bridge.posid;

    // Der Zehnerblock schreibt in dieses Feld (OK/X gehen ueber
    // controlFields, die Ziffern ueber POS.focusedComponent).
    bridge.components.container.components.numPad.controlFields = [input];

    // Der Fokus darf die Kassa nicht verlassen: das unsichtbare Feld gibt
    // ihn zurueck. Im Legacy wurde dafuer ebenfalls die Instanzmethode
    // ueberschrieben, nicht properties.events.
    bridge.components.hiddenInput.onFocus = bridge.restoreFocus;

    window.name = 'POSweb Kassa';
  },
  methods: {
    jumpNext(bridge) {
      bridge.components.container.components.posid.field.input.setFocus();
    },
    restoreFocus(bridge) {
      bridge.components.container.components.posid.field.input.setFocus();
    },
    // OKcallback des Eingabefeldes: Kassen-ID schreiben und neu laden.
    posid(bridge) {
      POS.hourGlass.show();
      var posid = bridge.components.container.components.posid.field.input.properties.attributes.value;
      if (posid == '')
        return;
      fs.writeFileSync('var/db/import/POSId', posid);
      location.reload();
    },
  },
});
